import { MutationTree } from 'vuex';
import { HomeState } from '@/store/types/home.state';

export const mutations: MutationTree<HomeState> = {
    setEntries(state, value) {
        state.entries = value;
        state.loading = false;
    },
    setArtEntries(state, value) {
        state.artEntries = value;
    },
    setWebEntries(state, value) {
        state.webEntries = value;
    },
    setAudiovisualEntries(state, value) {
        state.audiovisualEntries = value;
    },
    setSoftwareEntries(state, value) {
        state.softwareEntries = value;
    },
    setGraphicDesignEntries(state, value) {
        state.graphicDesignEntries = value;
    },
    setMusicEntries(state, value) {
        state.musicEntries = value;
    },
    setLoading(state, value) {
        state.loading = value;
    },
    setTypeDisplaying(state, value) {
        state.typeDisplaying = value;
    },
};
